module.exports = __webpack_public_path__ + "img/52.fb1760f6.png";